import * as AOS from "aos";

const aosJs = function () {
    AOS.init({
        offset: 0
    });
}

export default aosJs;